import {
  initFlagsmith,
  resetFeatureFlags,
  setFeatureFlagsInitialized,
  setFlagsmithUserTrait,
  setUserFeatureFlags,
} from './feature-flags.actions';
import {
  updateFeatureFlagsInitialized,
  updateFeatureFlags,
  resetFeatureFlagsStore,
} from './feature-flags.repository';
import {
  AvailableFeatureFlags,
  FeatureFlagMap,
} from '../../models/feature-flags';
import {
  createEffect,
  dispatch,
  ofType,
  registerEffects,
  tapResult,
} from '@ngneat/effects';
import flagsmith from 'flagsmith-es';
import { environmentProvider } from '@shared/environment-provider';

const env = environmentProvider.getEnvironment();

const initFlagsmith$ = createEffect((actions) =>
  actions.pipe(
    ofType(initFlagsmith),
    tapResult(({ user }) => {
      flagsmith.init({
        ...env.flagSmithConfig,
        identity: user.username,
        traits: {
          username: user.username,
          accountName: user.accountName,
          firstName: user.firstName,
          lastName: user.lastName,
          roles: user.roles.toString(),
        },
        onChange: () => {
          const flags = flagsmith.getAllFlags();
          const featureFlags: FeatureFlagMap = new Map(
            Object.entries(flags).map(([key, value]) => [
              key as AvailableFeatureFlags,
              value,
            ])
          );
          dispatch(setUserFeatureFlags({ featureFlags }));
          dispatch(
            setFeatureFlagsInitialized({ featureFlagsInitialized: true })
          );
        },
        onError: () => {
          dispatch(
            setFeatureFlagsInitialized({ featureFlagsInitialized: false })
          );
        },
      });
    })
  )
);

const setFeatureFlagsInitialized$ = createEffect((actions) =>
  actions.pipe(
    ofType(setFeatureFlagsInitialized),
    tapResult(({ featureFlagsInitialized }) => {
      updateFeatureFlagsInitialized(featureFlagsInitialized);
    })
  )
);

const setUserFeatureFlags$ = createEffect((actions) =>
  actions.pipe(
    ofType(setUserFeatureFlags),
    tapResult(({ featureFlags }) => {
      updateFeatureFlags(featureFlags);
    })
  )
);

const resetFeatureFlags$ = createEffect((actions) =>
  actions.pipe(
    ofType(resetFeatureFlags),
    tapResult(() => {
      resetFeatureFlagsStore();
    })
  )
);

const setFlagsmithUserTrait$ = createEffect((actions) =>
  actions.pipe(
    ofType(setFlagsmithUserTrait),
    tapResult(({ key, value }) => {
      flagsmith.setTrait(key, value);
    })
  )
);

const effects = [
  initFlagsmith$,
  setFeatureFlagsInitialized$,
  setUserFeatureFlags$,
  resetFeatureFlags$,
  setFlagsmithUserTrait$,
];

export function registerFeatureFlagsEffects() {
  registerEffects(effects);
}
